import { useResponsiveMediaQuery } from "@project/common"
import dayjs from "dayjs"
import { useRouter } from "next/router"
import { useFetchAllDailyRecordRequest } from "../../../../hooks"
import { CommonTabContent } from "../../common/CommonTabContent"
import { ResponsiveCommonTabContent } from "../../common/ResponsiveCommonTabContent"

export const EditRequestTabsContent = (): JSX.Element => {
  const router = useRouter()
  const { isTabletOrMobile } = useResponsiveMediaQuery()
  const { date, page } = router.query as any
  const currentDate = date
    ? dayjs(date).isValid
      ? dayjs(date)
      : dayjs()
    : dayjs()
  const { dailyRecordsRequest, isLoading } = useFetchAllDailyRecordRequest({
    page: page || 1,
    pageSize: 20,
    year: dayjs(currentDate).year(),
    month: dayjs(currentDate).month() + 1,
    request_type: 1,
  })
  if (isTabletOrMobile) {
    return (
      <ResponsiveCommonTabContent
        dailyRecordsRequest={dailyRecordsRequest}
        isLoading={isLoading}
        request_type={1}
        currentDate={currentDate}
        record_of={"edit-request-list"}
      />
    )
  }

  return (
    <CommonTabContent
      request_type={1}
      dailyRecordsRequest={dailyRecordsRequest}
      isLoading={isLoading}
    />
  )
}
